export default "__VITE_ASSET__C7bGGV8L__"